const prerender = {
  diasStatusCode410: 30,
}
export default prerender
